/**
 * Given a phone number in any format, this will return the phone number
 * in the `xxx-xxx-xxxx` format.
 * This will add trailing 0's for phone numbers shorter than 10 characters
 */
export function formatPhoneNumber(value) {
    return String(value)
        .replace(/\D/g, "")
        .concat("0".repeat(10))
        .slice(0, 10)
        .replace(/(\d{3})(\d{3})(\d*)/, "$1-$2-$3");
}
/**
 * Given a `format` with 3 capturing groups, ie: `$1-$2-$3`
 * this will return a formatting function using the provided `format`.
 */
export const customPhoneFormat = (format) => (value) => {
    return String(value)
        .replace(/[^\d]/g, "") // remove all non digits
        .replace(/(\d{3})(\d{3})(\d*)/, format);
};
/**
 * Given a phone number in any format, this will return the phone number
 * in the `(xxx) xxx-xxxx` format. This will not pad or omit any digits.
 */
export const formatPhoneDefault = customPhoneFormat("($1) $2-$3");
/**
 * Given a phone number in any format, this will return the phone number
 * in the `xxx-xxx-xxxx` format. This will not pad or omit any digits.
 */
export const formatPhoneHyphen = customPhoneFormat("$1-$2-$3");
export function formatTIN(value) {
    return String(value)
        .replace(/\D/g, "")
        .slice(0, 9)
        .replace(/(\d{2})(\d{7})/, "$1-$2");
}
export function formatSSN(value) {
    return String(value)
        .replace(/\D/g, "")
        .slice(0, 9)
        .replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
}
//# sourceMappingURL=index.js.map